import { PaymentMethod } from '../exports/Constants';

// The only methods the backend accepts for Adyen. `paywithgoogle` is the older Google Pay type some
// Drop-in configurations still report.
const ADYEN_PAYMENT_METHOD_TYPES = new Map<string, PaymentMethod>([
  ['scheme', PaymentMethod.Card],
  ['paybybank', PaymentMethod.PayByBank],
  ['googlepay', PaymentMethod.GooglePay],
  ['paywithgoogle', PaymentMethod.GooglePay],
  ['applepay', PaymentMethod.ApplePay],
]);

/** Maps an Adyen Drop-in payment method type to ours, or null for a type we do not map. */
export function castAdyenPaymentMethodType(adyenType: null | string | undefined): null | PaymentMethod {
  return ADYEN_PAYMENT_METHOD_TYPES.get(adyenType ?? '') ?? null;
}

/** Whether the backend takes this method through Adyen. */
export function isAdyenPaymentMethod(method: null | PaymentMethod | undefined): boolean {
  return Boolean(method) && [...ADYEN_PAYMENT_METHOD_TYPES.values()].includes(method);
}
